module.exports = __webpack_public_path__ + "img/checked.2f184cfb.png";